import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adm } from "../../lib/adminApi";
import { PageHead, Card } from "../../components/admin/ui";
import { money } from "../../lib/api";

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { adm.dashboard().then(setD).catch(() => {}); }, []);
  if (!d) return <p className="text-white/40 font-mono text-xs">LOADING…</p>;

  const stats = [
    ["Releases", d.releases, "/admin/releases"], ["Products", d.products, "/admin/store"],
    ["Orders", d.orders, "/admin/store"], ["Members", d.members, "/admin/inner-circle"],
    ["Subscribers", d.subscribers, "/admin/inner-circle"], ["Media", d.media, "/admin/media"],
    ["Active Whispers", d.whispers, "/admin/whispers"], ["Referral Signups", d.referralSignups, "/admin/network"],
    ["Supporters", d.supporters, "/admin/supporters"], ["Scheduled", d.scheduled, "/admin/releases"],
  ];

  return (
    <div data-testid="admin-dashboard">
      <PageHead title="Dashboard" sub="Operational overview of the Motion & Meaning universe." />
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {stats.map(([label, val, to]) => (
          <Link key={label} to={to} className="border border-white/10 bg-[#0a0a0a] p-4 hover:border-gold/50 transition-colors">
            <p className="font-serif text-3xl text-white">{val}</p>
            <p className="font-mono text-[8px] tracking-[0.2em] text-white/40 mt-1 uppercase">{label}</p>
          </Link>
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8">
        <Card>
          <p className="font-mono text-[10px] tracking-[0.3em] text-gold mb-4">RECENT ORDERS</p>
          {d.recentOrders.length === 0 && <p className="text-white/40 text-sm">No orders yet.</p>}
          {d.recentOrders.map((o) => (
            <div key={o.order_number} className="flex justify-between py-2.5 border-t border-white/5 text-sm">
              <span className="text-white/80 font-mono text-xs">{o.order_number}</span>
              <span className="text-white/40 text-xs truncate mx-3">{o.email}</span>
              <span className="text-gold font-mono text-xs">{money(o.amount, o.currency)}</span>
            </div>
          ))}
        </Card>
        <Card>
          <p className="font-mono text-[10px] tracking-[0.3em] text-gold mb-4">RECENT ACTIVITY</p>
          {d.recentActivity.length === 0 && <p className="text-white/40 text-sm">No admin activity recorded yet.</p>}
          {d.recentActivity.map((a) => (
            <div key={a.id} className="py-2.5 border-t border-white/5">
              <p className="text-xs text-white/70">{a.action} · <span className="text-white/40">{a.entityType}/{a.entityId}</span></p>
              <p className="font-mono text-[9px] text-white/30 mt-0.5">{a.actor} — {new Date(a.at).toLocaleString()}</p>
            </div>
          ))}
        </Card>
      </div>
    </div>
  );
}
